import { getClientPayments, GetClientPaymentsResponse, PaymentHistoryType } from '../api';
import { useLocation } from 'react-router-dom';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

interface UseClientPaymentsRequest {
  activeOnly?: boolean;
  from?: string;
  orgId: string | null | undefined;
  to?: string;
  type?: PaymentHistoryType;
}

export const useClientPayments = (
  payload: UseClientPaymentsRequest
): UseQueryResult<GetClientPaymentsResponse, Error> => {
  const {
    activeOnly,
    from,
    orgId,
    to,
    type
  } = payload;

  const location = useLocation();
  const clientOrgId = orgId ?? '';

  return useQuery({
    enabled: Boolean(orgId),
    queryFn: () => getClientPayments({
      activeOnly,
      from,
      orgId: clientOrgId,
      to,
      type
    }),
    queryKey: ['getClientPayments', location.pathname, orgId, activeOnly, from, to, type],
    retry: 1
  });
};